import React from "react";
import { Handle, Position } from "reactflow";
import { withTranslation } from "react-i18next";

import ResponseHeader from "./ResponseHeader";

import "./ResponseIntentNode.scss";

const ResponseIntentNode = ({ id }) => {
  return (
    <>
      <Handle type="target" position={Position.Left} />
      <Handle type="source" id={id} position={Position.Right} />
      <div className="response-node-container">
        <ResponseHeader id={id} />
      </div>
    </>
  );
};

export default withTranslation("common")(ResponseIntentNode);
